<script lang="ts">
	import Accordion from "./Accordion.svelte";
	import {Utils} from "./util";
	import type {Community} from "./model";
	import {Answer} from "./model";
	import {translations} from "./config";
	import YesNoTable from "./YesNoTable.svelte";

	export let communityData: Community | null = null;
	export let hideUI = false;

	/** Cast to answer */
	function a(a: any): Answer {
		return a;
	}
</script>

<div id="questions" hidden={communityData?.public_answers?.length > 0 ? '' : 'none'}>
    <h2 id="communityName">{Utils.chooseTranslation(communityData?.name)}</h2>
    <YesNoTable
            rows={communityData?.public_answers.map(an => ({ text: a(an).question.name, value: a(an).value, additionalInfo: a(an).additionalInfo })) || []}/>
    {#if !hideUI}
        <a id="websiteButton" style="display: {communityData?.website == null ? 'none' : ''}"
           href={Utils.urlify(communityData?.website)} class="btn-brand" target="_blank">
            {Utils.chooseTranslation(translations.website)}
        </a>
    {/if}
</div>
